import { Alert, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { fetchPublicExhibition, fetchPublicResearch, type PublicApiError, type PublicPublicationDetail } from './publicApi'

export default function PublicPublicationDetailPage({
  workspaceSlug,
  siteSlug,
  kind,
}: {
  workspaceSlug: string
  siteSlug: string
  kind: 'exhibition' | 'research'
}) {
  const { slug = '' } = useParams()
  const [data, setData] = useState<PublicPublicationDetail | null>(null)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`

  useEffect(() => {
    setData(null)
    setError(null)
    const fetcher = kind === 'exhibition' ? fetchPublicExhibition : fetchPublicResearch
    fetcher(workspaceSlug, siteSlug, slug)
      .then((r) => setData(r.data))
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug, slug, kind])

  if (error) return <div className="pub-page"><Alert type="error" message={error === 'Not Found' ? '未找到' : error} showIcon /></div>
  if (!data) return <div className="pub-page"><Skeleton active paragraph={{ rows: 8 }} /></div>

  return (
    <section className="details-section">
      <div className="details-layout">
        <aside className="details-sidebar">
          <div className="details-sidebar-sticky">
            {data.cover_url && <img className="details-cover" src={data.cover_url} alt={data.label} />}
            <h2 className="details-sidebar-title">{data.label}</h2>
          </div>
        </aside>
        <main className="details-main">
          <div className="details-content">
            <div className="details-summary">
              <h2>{data.label}</h2>
              <div className="meta">
                {data.venue && <span>地点：{data.venue}</span>}
                {data.author && <span>作者：{data.author}</span>}
                {data.start_date && <span>{data.start_date} – {data.end_date}</span>}
              </div>
              <p>{data.description_long || data.description}</p>
            </div>
            {data.related_items.length > 0 && (
              <div className="details-block">
                <h3>相关条目</h3>
                <div className="pub-grid">
                  {data.related_items.map((item) => (
                    <Link key={item.slug} to={`${base}/items/${item.slug}`} className="pub-card">
                      <div className="pub-card-cover">{item.cover_url && <img src={item.cover_url} alt={item.label} />}</div>
                      <div className="pub-card-body">
                        <p className="pub-card-title">{item.label}</p>
                        <p className="pub-card-meta">{item.creator || item.era}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </section>
  )
}
